import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import BankAccountList from "../../components/BankAccount/List/BankAccountList";
import { routerLinks } from "../../hoc/Router/routerLinks";
import { BANK_ACCOUNT_LIST } from "../../hoc/Router/routerTypes";

const BankAccountListPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp
        items={[
          {
            title: "لیست حساب های بانکی",
            to: routerLinks(BANK_ACCOUNT_LIST),
          },
        ]}
      />

      <Grid container={true}>
        <Grid item xs={12}>
          <BankAccountList />
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default BankAccountListPage;
